// ShopProfileModal.tsx
import React, { useState, useEffect } from "react";
import { Modal, Button, Row, Card, Col } from "react-bootstrap";
import "./clientmodal.css";
import { useGetPurchaseByMarketerQuery, useUpdateTaskStatusMutation } from "../../../../features/marketing/marketingApiSlice";
import { getAsset } from "../../../../helpers/helper";


const MyClientsModal = ({ show, onHide }) => {
  const marketerId = localStorage.getItem("MeAsmarketerId");
  const [searchId, setSearchId] = useState("");

  useEffect(() => {
    if (!show) {
      setSearchId("");
    }
  }, [show]);

  // Fetch clients using RTK Query
  const { data: responseData } = useGetPurchaseByMarketerQuery(marketerId, {
    skip: !marketerId || !show,
  });

  const clients = responseData?.data || [];

  const [updateTaskStatus] = useUpdateTaskStatusMutation();

  const handleStartWork = async (item, shop) => {
    try {
      await updateTaskStatus({
        purchaseId: item._id,
        taskStatus: "inProgress",
      }).unwrap();
      onHide();
    } catch (error) {
      console.error("FAILED TO START WORK:", error);
    }
  };

  const pendingClients = clients.filter(client => {
    const isPending = client.taskStatus === "pending";
    if (!isPending) return false;
    if (!searchId.trim()) return true;

    const query = searchId.trim().toLowerCase();
    const shopIdValue = String(client.shopid?.shopid || "").toLowerCase();
    const mongoIdValue = String(client.shopid?._id || "").toLowerCase();

    return shopIdValue.includes(query) || mongoIdValue.includes(query);
  });

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="lg"
      className="shop-modal"
      dialogClassName="modal-90w"
    >
      <Modal.Header closeButton className="border-0 pb-0" />

      <Modal.Body className="mt-4">
        {/* Search Bar */}
        <div className="w-100">
          <div className="search-bar-container">
            <span className="text-muted fw-medium show-hide-class">
              Shop Profile by Id
            </span>
            <input
              type="text"
              placeholder="Enter shop ID..."
              value={searchId}
              onChange={(e) => setSearchId(e.target.value)}
            />
            <Button variant="primary" className="rounded-pill px-4">
              Search
            </Button>
          </div>
        </div>

        <Row className="g-4 mt-3">
          {pendingClients.length === 0 ? (
            <Col>
              <p className="text-center text-muted">No pending clients found.</p>
            </Col>
          ) : (
            pendingClients.map((item, index) => {
              const shop = item.shopid;
              const plan = item.planId;

              return (
                <Col key={item._id || index} md={6} lg={4} xl={4}>
                  <Card
                    className="h-100 border-0 shadow-sm"
                    style={{ borderRadius: "12px", overflow: "hidden" }}
                  >
                    {/* Status Badge */}
                    <div
                      className="position-absolute top-0 start-0 m-2 text-white"
                      style={{
                        backgroundColor:
                          item.paymentStatus === "success"
                            ? "#198754"
                            : "#ffc107",
                        padding: "0.2rem 0.5rem",
                        borderRadius: "4px",
                        fontSize: "0.7rem",
                        fontWeight: "bold",
                      }}
                    >
                      PAYMENT {item.paymentStatus.toUpperCase()}
                    </div>

                    {/* Share */}
                    <div
                      className="position-absolute top-0 end-0 m-2 text-white d-flex align-items-center gap-1"
                      style={{
                        backgroundColor: "#0353a4",
                        padding: "0.2rem 0.5rem",
                        borderRadius: "4px",
                        fontSize: "0.7rem",
                        cursor: "pointer",
                      }}
                    >
                      <i className="bi bi-share"></i>
                      <span className="d-none d-md-inline">Share</span>
                    </div>

                    {/* Shop Image */}
                    <div
                      style={{
                        height: "140px",
                        backgroundColor: "#f0f0f0",
                        backgroundImage: `url(${getAsset(shop?.image?.[0]) || ""})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                      }}
                    />

                    <Card.Body className="p-3">
                      <div className="d-flex justify-content-between align-items-start mb-1">
                        <h6
                          className="mb-0"
                          style={{ fontSize: "0.95rem", fontWeight: 600 }}
                        >
                          {shop?.shopname || "Unnamed Shop"}
                        </h6>
                        <small className="text-muted" style={{ fontSize: "0.8rem" }}>
                          (Views {shop?.visitCount || 0})
                        </small>
                      </div>

                      <div className="d-flex justify-content-between mb-1">
                        <p className="mb-0" style={{ fontSize: "0.8rem", color: "#6c757d" }}>
                          ID : {shop?.shopid ? btoa(shop.shopid) : ""}
                        </p>
                        <span style={{ fontSize: "0.75rem", fontWeight: 600 }}>
                          {plan?.planName}
                        </span>
                      </div>

                      <p
                        className="mb-2"
                        style={{ fontSize: "0.85rem", color: "#6c757d" }}
                      >
                        {shop?.shopaddress}
                      </p>

                      <div className="d-flex gap-2">
                        {item.paymentStatus === "success" ? (
                          <button
                            className="flex-grow-1 text-white btn"
                            style={{
                              backgroundColor: "#0d6efd",
                              border: "none",
                              fontSize: "0.8rem",
                              borderRadius: "20px",
                            }}
                            onClick={() => handleStartWork(item, shop)}                          >
                            Start Work
                          </button>
                        ) : (
                          <button
                            className="flex-grow-1 btn"
                            disabled
                            style={{
                              fontSize: "0.8rem",
                              borderRadius: "20px",
                              backgroundColor: "#e9ecef",
                              color: "#6c757d",
                              border: "1px solid #ced4da",
                              cursor: "not-allowed",
                            }}
                          >
                            Awaiting Payment
                          </button>
                        )}

                        <button
                          className="flex-grow-1 btn btn-outline-secondary"
                          disabled={item.paymentStatus !== "success"}
                          style={{
                            fontSize: "0.8rem",
                            borderRadius: "20px",
                            color: item.paymentStatus === "success" ? "#0353a4" : "#adb5bd",
                            borderColor: "#ced4da",
                            cursor:
                              item.paymentStatus === "success" ? "pointer" : "not-allowed",
                          }}
                        >
                          Connect
                        </button>
                      </div>

                    </Card.Body>
                  </Card>
                </Col>
              );
            })
          )}
        </Row>
      </Modal.Body>
    </Modal>
  );
};

export default MyClientsModal;
